import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';
import { haveStopsRoutePlanStale } from '@/components/shipment/form/utils/have-stops-route-plan-stale';
import type { ShipmentFormChangeSet } from '@/composables/shipment-form-change-set';

export type ShipmentFormSaveGuardValidation = {
  validateGeneralFields: (options: {
    requireName?: boolean;
    requirePlannedRange?: boolean;
  }) => boolean;
  assertNotRoutingBusy: (
    isRoutingBusy: () => boolean,
    message: string,
  ) => boolean;
};

export async function validateStopsForSave(input: {
  validateGeneralFields: ShipmentFormSaveGuardValidation['validateGeneralFields'];
  validateStops: () => Promise<boolean>;
  requirePlannedRange: boolean;
}): Promise<boolean> {
  const ok = input.validateGeneralFields({
    requireName: false,
    requirePlannedRange: input.requirePlannedRange,
  });
  if (!ok) return false;
  return input.validateStops();
}

export function assertRoutingNotBusy(
  validation: ShipmentFormSaveGuardValidation,
  isRoutingBusy: () => boolean,
  message = 'Wait for the route to finish calculating before saving.',
): boolean {
  return validation.assertNotRoutingBusy(isRoutingBusy, message);
}

export function assertRoutePlanNotStale(
  changeSet: ShipmentFormChangeSet,
  stops: ShipmentFormStopRow[],
  serverHydratedRouteFingerprint: string | null,
): boolean {
  if (changeSet.routes !== 'recreate') return true;
  return !haveStopsRoutePlanStale(stops, serverHydratedRouteFingerprint);
}

export function changeSetNeedsStopsValidation(
  changeSet: ShipmentFormChangeSet,
): boolean {
  return changeSet.stops === 'changed' || changeSet.routes !== 'unchanged';
}
